import { render, staticRenderFns } from "./MediaManage.vue?vue&type=template&id=d152f7c4&scoped=true"
import script from "./MediaManage.vue?vue&type=script&lang=js"
export * from "./MediaManage.vue?vue&type=script&lang=js"
import style0 from "./MediaManage.vue?vue&type=style&index=0&id=d152f7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d152f7c4",
  null
  
)

export default component.exports